import React from "react";
import FAQsView from "views/static/FAQs";

function FAQs() {
  return <FAQsView />;
}
export default FAQs;
